import { Box, Button, Dialog, DialogContent, Divider, Grid, Typography, useMediaQuery } from '@mui/material';
import NumberFormat from 'react-number-format';
import WhiteInosio from "../../../icons/whiteinosio.svg";
import { convertCentsToDollars } from "../../../shared/util/converters";
import { useDispatch, useSelector } from 'react-redux';
import { selectPaymentRequestsState } from '../../../pmui/paymentrequests/sagas/paymentrequestslice';
import { selectQuickPaymentsState } from '../sagas/quickpaymentsSlice';
import { format } from 'date-fns';
import ExportIcon from "../../../icons/exportIcon2.svg";
import { getExportTransDetails } from '../../../pmui/transactions/sagas/pmTransactionsSlice';
import { selectPropertyGroupDetailsState } from '../../../shared/sagas/propertyGroups/propertyGroupsSlice';

interface QuickPayThankYouPaymentDialogProps {
  open: boolean;
  onCancel: () => void
}

const QuickPayThankYouPaymentDialog = (props: QuickPayThankYouPaymentDialogProps) => {
  const { open, onCancel } = props;
  const isOnMobileScreen = useMediaQuery("(max-width:600px)");

  const dispatch = useDispatch();

  // const { companyResponse } = useSelector(selectApplicationsState);
  const { propertyGroupDetails: PropertyGroupDetails } = useSelector(selectPropertyGroupDetailsState);
  const { quickPayOtpDto, propertyAddress, genericPayerResponse, QPTransactionDto } = useSelector(selectQuickPaymentsState);

  const style = {
    height: isOnMobileScreen ? "100%" : "523px"
  };

  const { errorCancelTransaction } = useSelector(selectPaymentRequestsState);
  return (
    <Dialog
      open={open}
      fullScreen={isOnMobileScreen}
      BackdropProps={{
        invisible: true,
      }}
      fullWidth={true}
      disableEnforceFocus
      style={{
        background: "none",
      }}
      PaperProps={{
        style: {
          pointerEvents: "auto",
          borderRadius: isOnMobileScreen ? "0px" : "24px",
          width: isOnMobileScreen ? "100%" : "472px",
          boxShadow: "none",
          overflow: "hidden"
        },
      }}
      disableEscapeKeyDown={true}
    >
      <DialogContent>
        <Box sx={style}>
          <Grid item display='flex' justifyContent='space-between' flexDirection='column' sx={{ height: '100%' }} >
            <Grid item display="flex" flexDirection="column">
              {isOnMobileScreen ?
                <Grid item display='flex' justifyContent='center'>
                  <Grid item display='flex' pl={4} sx={{ width: '340px' }}>
                    <img src={WhiteInosio} style={{ width: "75px", height: "75px" }} alt="logo" />
                    <Typography
                      sx={{
                        fontFamily: "Work Sans",
                        fontStyle: 'normal',
                        fontWeight: 700,
                        fontSize: '18px',
                        lineHeight: '23px',
                        color: '#14142B',
                        textAlign: 'left',
                        padding: '15px'
                      }}>
                      {PropertyGroupDetails?.CompanyName}
                    </Typography>
                  </Grid>
                </Grid>
                : <></>}
              <Typography id='thank-you-for-payment'
                sx={{
                  fontFamily: "Work Sans",
                  fontStyle: 'normal',
                  fontWeight: 700,
                  fontSize: '18px',
                  lineHeight: '23px',
                  color: '#14142B',
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '30px'
                }}>
                Thank you for your payment.
              </Typography>

              <Typography
                style={{
                  color: "#14142B",
                  fontSize: "14px",
                  textAlign: "center",
                }}
                sx={{ mt: 2 }}
                id="review-submit-main-details"
              >
                Your payment is credited to your account immediately. However, it may take up to three business days to reflect on your card or bank statement.
              </Typography>

              <Typography id="payment-id" sx={{ mt: 2, mb: 2, textAlign: 'center' }}>
                Payment ID: {QPTransactionDto.TransactionUuid}
              </Typography>
              {errorCancelTransaction?.message ? (
                <Grid item mt={1}>
                  <Typography
                    style={{
                      fontFamily: "'Open Sans', sans-serif",
                      fontStyle: "normal",
                      fontWeight: 500,
                      fontSize: "14px",
                      lineHeight: "18px",
                      color: "#DB3939",
                      textAlign: "center",
                      borderTop: errorCancelTransaction?.message?.length ? "2px  solid #DB3939" : '',
                      borderRadius: "24px",
                      padding: "12px 20px",
                      width: isOnMobileScreen ? '240px' : "340px",
                      margin: "0px auto",
                    }}
                  >
                    {errorCancelTransaction?.message}
                  </Typography>
                </Grid>                
              ) : (
                <></>
              )}
              <Grid item xs={12} display='flex' justifyContent={'space-between'} mt={1}>
                <Typography sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "22px",
                  fontFamily: "Work Sans",
                }}>
                  {PropertyGroupDetails?.CompanyName}
                </Typography>

                <Typography sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "22px",
                  fontFamily: "Work Sans",
                }}>
                  {propertyAddress || 'Quick Payment'}
                </Typography>
              </Grid>
              <Grid item xs={12} display='flex' justifyContent={'space-between'} mt={1}>
                <Typography sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "22px",
                  fontFamily: "Work Sans",
                }}>
                  {`${genericPayerResponse?.FirstName} ${genericPayerResponse?.LastName}`}
                </Typography>

                <Typography sx={{
                  fontWeight: 600,
                  fontSize: "16px",
                  lineHeight: "22px",
                  fontFamily: "Work Sans",
                }}>
                  {genericPayerResponse?.Email}
                </Typography>
              </Grid>
              <Grid item xs={12} mt={2}>
                <Grid item xs={12} mt={1} mb={1}>
                  {<Divider sx={{ width: '100%' }} />}
                </Grid>
                <Grid item xs={12} display='flex' justifyContent={'space-between'} mt={1.5} ml={1} mr={2}>
                  <Grid item xs={9.5}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: "22px",
                        fontFamily: "Work Sans",
                        color: '#D3D3D3'
                      }}>
                      Payment Method
                    </Typography>
                  </Grid>
                  <Grid item xs={2.5}>
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "16px",
                        lineHeight: "22px",
                        fontFamily: "Work Sans",
                        color: '#D3D3D3'
                      }}>
                      {QPTransactionDto.TransactionDetails?.[0]?.FromPayMethod?.AccountLastFour}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} display='flex' justifyContent={'space-between'} mt={1.5} ml={1} mr={2}>
                  <Grid item xs={9.5}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: "22px",
                        fontFamily: "Work Sans",
                        color: '#D3D3D3'
                      }}>
                      {'Amount'}
                    </Typography>
                  </Grid>
                  <Grid item xs={2.5}>
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "16px",
                        lineHeight: "22px",
                        fontFamily: "Work Sans",
                        color: '#D3D3D3'
                      }}>
                      <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={convertCentsToDollars(quickPayOtpDto.TotalAmount - (quickPayOtpDto.FeeAmount ?? 0))}
                        prefix="$"
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        allowNegative={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} display='flex' justifyContent={'space-between'} mt={1.5} ml={1} mr={2}>
                  <Grid item xs={9.5}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: "22px",
                        fontFamily: "Work Sans",
                        color: '#D3D3D3'
                      }}>
                      Fee Amount
                    </Typography>
                  </Grid>
                  <Grid item xs={2.5}>
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "16px",
                        lineHeight: "22px",
                        fontFamily: "Work Sans",
                        color: '#D3D3D3'
                      }}>
                      <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={convertCentsToDollars(quickPayOtpDto.FeeAmount ?? 0)}
                        prefix="$"
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        allowNegative={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} display='flex' justifyContent={'space-between'} mt={1.5} ml={1} mr={2}>
                  <Grid item xs={9.5}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: "22px",
                        fontFamily: "Work Sans",
                        color: '#D3D3D3'
                      }}>
                      Total Amount
                    </Typography>
                  </Grid>
                  <Grid item xs={2.5}>
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "16px",
                        lineHeight: "22px",
                        fontFamily: "Work Sans",
                        color: '#D3D3D3'
                      }}>
                      <NumberFormat
                        thousandsGroupStyle="thousand"
                        value={convertCentsToDollars(quickPayOtpDto.TotalAmount ?? 0)}
                        prefix="$"
                        decimalSeparator="."
                        displayType="text"
                        type="text"
                        thousandSeparator={true}
                        allowNegative={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} display='flex' justifyContent={'space-between'} mt={1.5} ml={1} mr={2}>
                  <Grid item xs={9.5}>
                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: "22px",
                        fontFamily: "Work Sans",
                        color: '#D3D3D3'
                      }}>
                      Transaction Date
                    </Typography>
                  </Grid>
                  <Grid item xs={2.5}>
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "16px",
                        lineHeight: "22px",
                        fontFamily: "Work Sans",
                        color: '#D3D3D3'
                      }}>
                      {QPTransactionDto.TransactionDate ? format(new Date(QPTransactionDto.TransactionDate), "MM/dd/yy"): ''}
                    </Typography>
                  </Grid>
                </Grid>
                <Grid item xs={12} display='flex' justifyContent={'space-between'} mt={1.5} ml={1} mr={2}>
                  <img
                    src={ExportIcon}
                    alt="close"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      dispatch({
                        type: getExportTransDetails.type,
                        payload: QPTransactionDto.TransactionUuid,
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid>
              <Grid item xs={12} p={1} display='flex' flexDirection={isOnMobileScreen ? 'column' : 'row'} justifyContent='start'>
                {isOnMobileScreen ?
                  <Button id='cancel-fund' variant="outlined"
                    style={{
                      borderRadius: "24px",
                      textTransform: "capitalize",
                      color: "#DB3939",
                      borderColor: "#DB3939",
                      height: '49px',
                      width: isOnMobileScreen ? '100%' : '150px',

                    }} onClick={onCancel}>
                    Cancel Payment
                  </Button>
                  : <><Button id='cancel-fund' variant="outlined"
                    style={{
                      borderRadius: "24px",
                      textTransform: "capitalize",
                      color: "#DB3939",
                      borderColor: "#DB3939",
                      height: '49px',
                      width: '150px',
                    }} onClick={onCancel}>
                    Cancel Payment
                  </Button></>
                }
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
    </Dialog>

  );

}
export default QuickPayThankYouPaymentDialog;
